enum ProductType {
  warrantyTierBased = 'WARRANTY_TIER-BASED',
  warrantiClassBased = 'WARRANTY_CLASS-BASED',
  nonWarranty = 'NON-WARRANTY',
  custom = 'CUSTOM',
}
export default ProductType;
export type VerifyProductType = Utils.VerifyExtends<Model.Enum.ProductType, Utils.ValueOf<typeof ProductType>>;
